module.exports = "@media only screen and (max-width: 767px) {\n  .filters {\n    display: none; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/filter/filter.component.scss
// module id = ./src/app/filter/filter.component.scss
// module chunks = main